import React, { Component } from "react";

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li>
                        <a href="https://play.google.com/store/apps/details?id=com.silibrain.busted">
                            <img src="/assets/images/brand/brand-01.png" alt="BUSTED"/>
                        </a>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;